import { useEffect } from "react";
import { captureUtmParams } from "@/lib/utmTracking";

/**
 * Component that captures UTM params on mount
 * Should be placed high in component tree (App.tsx)
 */
export const UtmCapture = () => {
  useEffect(() => {
    captureUtmParams();
  }, []);

  return null;
};

export default UtmCapture;
